import React from "react";

import { validMobile } from "@origin-digital/validation";

import { pageRoutes } from "src/consts";
import { UpdatePhone } from "../UpdatePhone";

import { FieldUpdateHook } from "../../../crm/profileFieldMap";
import { ProfileFieldMapTypes } from "../../../crm/profileFieldMapContextHelpers";
import content from "./content.json";

export const UpdateMobileScreen: React.FC<{
  mobile: string | null;
  useUpdate: FieldUpdateHook<string>;
  type: ProfileFieldMapTypes;
}> = ({ mobile, useUpdate, type }) => (
  <UpdatePhone
    value={mobile}
    content={content}
    useUpdatePhone={useUpdate}
    updateSuccessRoute={pageRoutes.updateMobile.success}
    type="mobile"
    validator={validMobile(content.phone.errors)}
    fieldMapType={type}
  />
);
